import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, impressaoComunicacaoVenda } from './types';

export const INITIAL_STATE: impressaoComunicacaoVenda = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): impressaoComunicacaoVenda {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRESSAO_COMUNICACAO_VENDA_REQUEST: {
				break;
			}

			case Types.IMPRESSAO_COMUNICACAO_VENDA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_COMUNICACAO_VENDA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRESSAO_COMUNICACAO_VENDA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
